import React from "react";
import type { ComponentType } from "react";

import { Guid } from "../Engine/Types/Guid";
import { useShowOnce, UseShowOnceResponse } from "../../../Common/UseShowOnce";

import { BANNER_CLOSE } from "./metricsAction";
import { BannerProps } from "./FormParts/Banner/Banner";

export interface WithShowOnceBannerProps extends BannerProps {
    id: string;
    userId?: Guid;
    children?: React.ReactNode;
}

export function withShowOnceBanner<P extends WithShowOnceBannerProps>(
    WrappedComponent: ComponentType<P>
): ComponentType<P> {
    return function WithShowOnceWrapper(props: P) {
        if (!props.userId) {
            return <WrappedComponent {...props} />;
        }

        return (
            <ShowOnce
                nidusKey={props.userId}
                infoName={props.name}
                openFromMetricName={props.name}
                renderBanner={({ isOpen, setIsOpen, addToNidus }) => (
                    <WrappedComponent {...props} isOpen={isOpen} setIsOpen={setIsOpen} onClose={addToNidus} />
                )}
            />
        );
    };
}

interface ShowOnceProps {
    nidusKey: string;
    infoName: string;
    openFromMetricName: string;
    renderBanner: (args: UseShowOnceResponse) => JSX.Element;
}
const ShowOnce = ({ infoName, nidusKey, openFromMetricName, renderBanner }: ShowOnceProps) => {
    const { isOpen, setIsOpen, addToNidus } = useShowOnce({
        nidusName: "banner",
        nidusKey: nidusKey,
        infoName: infoName,
        onCloseMetricName: BANNER_CLOSE,
        openFromMetricName: openFromMetricName,
    });
    return renderBanner({ isOpen: isOpen, setIsOpen: setIsOpen, addToNidus: addToNidus });
};
